import { env } from '@/libs/env'

export default {
  'Account Settings': 'Cài đặt tài khoản',
  'Agency Settings': 'Cài đặt thông tin đại lý',
  'Change Password': 'Đổi mật khẩu',
  'Knowledge Base': 'Knowledge Base',
  List: 'List',
  Detail: 'Chi tiết',
  Edit: 'Sửa',
  Search: 'Tìm kiếm',
  Results: 'Kết quả tìm kiếm',
  Support: 'Support',
  'Raise Support': 'Raise Support',
  Documentations: env.isInfoPortalTitleReplaceDocuments ? 'Cổng thông tin' : 'Tài liệu',
  Dashboards: 'Bảng điều khiển',
  eCommerce: 'eCommerce',
  Analytics: 'Thống kê',
  'Apps & Pages': 'Apps & Pages',
  Invoice: 'Hóa Đơn',
  'Invoice List': 'Danh sách hóa đơn',
  'Invoice Additional List': 'Danh sách hóa đơn xuất chênh',
  'Invoice Request List': 'Danh sách yêu cầu xuất hóa đơn',
  'Invoice Create': 'Lập hoá đơn',
  'Invoice Request Create': 'Tạo yêu cầu xuất hoá đơn',
  'Invoice Create And Request Release': 'Tạo Hóa đơn và gửi yêu cầu ký',
  'Invoice Detail': 'Chi tiết hoá đơn',
  'Invoice Replace': 'Thay thế hoá đơn',
  'Invoice Adjust': 'Điều chỉnh hoá đơn',
  'Invoice Duplicate': 'Nhân bản hoá đơn',
  'Invoice Preview': 'Xem hoá đơn',
  'Invoice Request Detail': 'Chi tiết yêu cầu xuất hoá đơn',
  'Certificate Manage': 'Cài đặt chứng thư số',
  'Invoices Release Batches': 'Quản lý lô phát hành HĐ',
  'Release Registration': 'Đăng ký phát hành',
  Declaration: 'Tờ khai',
  'Authorization Declaration': 'Tờ khai uỷ nhiệm',
  'Invoice Template': 'Mẫu hoá đơn',
  'Incorrect Invoices List': 'Thông báo sai sót',
  'Incorrect Invoice Create': 'Lập thông báo sai sót',
  'Incorrect Invoice Detail': 'Chi tiết thông báo sai sót',
  'Incorrect Invoice Preview': 'Xem thông báo sai sót',
  Preview: 'Preview',
  Add: 'Add',
  Details: 'Details',
  View: 'View',
  Authentication: 'Authentication',
  'Login v1': 'Login v1',
  'Login v2': 'Login v2',
  'Register v1': 'Register v1',
  'Register v2': 'Register v2',
  'Forget Password v1': 'Forget Password v1',
  'Forget Password v2': 'Forget Password v2',
  'Forgot Password v1': 'Forgot Password v1',
  'Forgot Password v2': 'Forgot Password v2',
  'Reset Password v1': 'Reset Password v1',
  'Reset Password v2': 'Reset Password v2',
  'Coming Soon': 'Coming Soon',
  'Not Authorized': 'Not Authorized',
  'Under Maintenance': 'Under Maintenance',
  Error: 'Lỗi',
  Statistics: 'Statistics',
  Apps: 'Apps',
  'User Interface': 'User Interface',
  'Mail Templates': 'Mail Templates',
  Welcome: 'Welcome',
  'Reset Password': 'Reset Password',
  'Verify Email': 'Verify Email',
  'Deactivate Account': 'Deactivate Account',
  Promotional: 'Promotional',
  'Page Layouts': 'Page Layouts',
  'Collapsed Menu': 'Collapsed Menu',
  'Layout Boxed': 'Layout Boxed',
  'Without Menu': 'Without Menu',
  'Layout Empty': 'Layout Empty',
  'Layout Blank': 'Layout Blank',
  Case: 'Case',
  Queue: 'Queue',
  'Preview temp': 'Preview temp',
  10: '10',

  Booking: 'Đặt vé',
  Bookings: 'Đặt vé',
  Reservations: 'Danh sách đặt chỗ',
  'Reservation Detail': 'Chi tiết đặt chỗ',
  'Reservation Ticket': 'Mặt vé',
  HOLD: 'Giữ chỗ',
  PAID: 'Đã thanh toán',
  CANCEL: 'Đã huỷ',
  EXPIRED: 'Quá hạn',
  Customer: 'Khách hàng',
  Employee: 'Nhân viên',
  Agency: 'Đại lý',
  Contract: 'Hợp đồng',
  Receipt: 'Biên lai',
  Receipts: 'Biên lai',
  Document: 'Tài liệu',
  Account: 'Tài khoản',
  Documents: 'Documents',

  'Create New Employee': 'Thêm nhân viên',
  'Employee management': 'Quản lý nhân viên',
  'Create New': 'Thêm mới',
  'Employee detail': 'Chi tiết nhân viên',
  'Employee List': 'Danh sách nhân viên',
  'Create New Customer': 'Thêm khách hàng',
  'Customer management': 'Quản lý khách hàng',
  'Customer detail': 'Chi tiết khách hàng',
  'Customer List': 'Danh sách khách hàng',
  'Contact Add': 'Thêm liên hệ',
  Contacts: 'Liên hệ',
  'Contact Edit': 'Chỉnh sửa liên hệ',
  'Create New Agency': 'Thêm đại lý',
  'Agency Management': 'Quản lý đại lý',
  'Agency Detail': 'Chi tiết đại lý',
  'Agency List': 'Danh sách đại lý',
  'Create New Receipt': 'Tạo biên lai',
  'Receipt Management': 'Quản lý biên lai',
  'Receipt Detail': 'Thông tin biên lai',
  'Receipt List': 'Danh sách biên lai',
  Flight: 'Đặt chuyến bay',
  'Flight v2': 'Đặt chuyến bay',
  general: 'Thông tin chung',
  changePassword: 'Đổi mật khẩu',
  'Search flights': 'Tìm kiếm chuyến bay',
  Tickets: 'Vé',
  'Error Notification': 'Thông báo sai sót',
  'Accounts payable general': 'Công nợ tổng hợp',
  'Accounts payable': 'Công nợ',
  'Account Payable Retail': 'Công nợ tổng hợp bán lẻ',
  'Accounts payable list': 'Danh sách công nợ',
  'Detail accounts payable': 'Chi tiết công nợ',
  'Update accounts payable': 'Cập nhật công nợ',
  'Import accounts payable': 'Nhập từ Excel',
  'Sale Report': 'Báo cáo bán chi tiết',
  'Sale Report Retail': 'Báo cáo bán chi tiết bán lẻ',
  'Sale Report Refund Ticket': 'Hoàn định danh VJ',
  Role: 'Vai trò',

  // ANCHOR: Configs
  Settings: 'Cài đặt',
  'My account': 'Tài khoản',
  'Agency account': 'Thông tin đại lý',
  Configs: 'Cài đặt',
  'Fee Configs': 'Phí xuất vé',
  'Service Fee Configs': 'Phí dịch vụ khách lẻ',
  electronicTicket: 'Cài đặt mặt vé',
  electronicTicketTrain: 'Cài đặt mặt vé tàu',
  configsDisplay: 'Cài đặt hiển thị',
  systemConfigs: 'Cài đặt hệ thống',
  'Send Notification': 'Gửi thông báo',
  // ANCHOR: Sale report
  'Create sale report manually': 'Tạo báo cáo bán thủ công',
  'Sale report detail': 'Chi tiết báo cáo bán',

  Promotion: 'Hoa hồng',
  // ANCHOR: Promotion AG
  'Promotion AG': 'Hoa hồng AG',
  'Promotion AG List': 'Danh sách hoa hồng AG',
  'Create New Promotion AG': 'Thêm mới hoa hồng AG',
  'Promotion AG detail': 'Chi tiết hoa hồng AG',

  // ANCHOR: Promotion Airline
  'Promotion Airline': 'Khuyến mãi hãng',
  'Promotion Airline List': 'Danh sách khuyến mãi hãng',
  'Create New Promotion Airline': 'Thêm mới khuyến mãi hãng',
  'Promotion Airline Detail': 'Chi tiết khuyến mãi hãng',

  // ANCHOR: Promotion User
  'Promotion User': 'Khuyến mãi hãng theo tài khoản',
  'Promotion User List': 'Danh sách khuyến mãi hãng theo tài khoản',
  'Create New Promotion User': 'Thêm khuyến mãi hãng theo tài khoản',
  'Promotion User Detail': 'Chi tiết khuyến mãi hãng theo tài khoản',

  // ANCHOR : Work Schedule
  'Work Schedule': 'Lịch trực',
  'Work Schedule List': 'Danh sách lịch trực',
  'Create Work Schedule': 'Tạo lịch trực',

  // ANCHOR: Airlines 1G can pay
  'Airlines 1G can pay': 'Hãng xuất vé',

  // ANCHOR Document Management cong van tai lieu
  'Document Management': 'Quản lý tài liệu',
  'Folder list': 'Danh sách thư mục',
  'Document list': 'Danh sách tài liệu',
  'Create New Document': 'Thêm mới tài liệu',
  'Document Detail': 'Chi tiết tài liệu',

  // ANCHOR: Flight Preparation list
  'Flight Preparation': 'Vé sắp bay',
  'Flight Preparation List': 'Danh sách Vé sắp bay',

  // ANCHOR Agency Balance
  'Agency Balance': 'Số dư hãng',

  // ANCHOR Find Booking Vietjet
  'Find Booking Vietjet': 'Tra cứu vé Vietjet',
  // ANCHOR retail
  Retail: 'Bán lẻ',
  'Retail Report': 'Báo cáo tổng hợp',
  'Retail Bookings': 'Danh sách đặt chỗ bán lẻ',
  'Retail Config Service Fee': 'Cài đặt phí dịch vụ',

  // ANCHOR booking statistic
  'Booking Statistic': 'Thống kê giữ chỗ',
  'Low Fare Tracking Statistic': 'Quản lý canh vé rẻ',
  'Past Day Booking List': 'Danh sách vé qua ngày bay',
  Terminals: 'Terminals',

  'Reference Data Search': 'Tra cứu thông tin dữ liệu',
  Utils: 'Tiện ích',
  'Agency package configs': 'Các gói đang hoạt động',
  'Agency package history': 'Lịch sử sử dụng',
  'Agency package order': 'Quản lý đơn hàng',
  'Package configs': 'Gói dịch vụ Websites/API/Bán lẻ',
  'Package websites/API configs': 'Gói dịch vụ websites/API',
  'Package configs create': 'Tạo gói dịch vụ',
  'Package configs detail': 'Chi tiết gói dịch vụ',
  'Package Coupons': 'Mã giảm giá',
  'Check-in cancellation VNA': 'Gỡ checkin VNA',
  'Check-in cancellation Bamboo': 'Gỡ checkin Bamboo',
  'Entry declaration': 'Khai nhập cảnh',
  Thailand: 'Thái Lan',
  'Entry declaration Thailand': 'Tờ khai nhập cảnh Thái Lan',
  'Entry declaration Singapore': 'Tờ khai nhập cảnh Singapore',
  titleRepicient: 'Yêu cầu nạp tiền',
  titleSender: 'Nạp tiền',
  officialDispatch: 'Công văn',
  sepayManager: 'Tích hợp sepay',
  'Bank accounts': 'Tài khoản ngân hàng',
  Transactions: 'Giao dịch',
  Companies: 'Tổ chức',
  'Resell Ticket': 'Shop định danh',
  'Search resell Ticket': 'Danh sách định danh',
  'Manager Resell Ticket': 'Quản lý định danh',
  suggestShopVJ: 'Gợi ý định danh',
  'Support Request': 'Yêu cầu gọi tổng đài',
  Banks: 'Ngân hàng',
  Train: 'Vé tàu',
  'Train Search Fares': 'Ga tàu, giá vé',
  'Train Ticket Search': 'Tra cứu thông tin vé',
  'Train Ticket List': 'Danh sách vé',
  'Train Ticket Detail': 'Chi tiết vé',
  'Train Search': 'Tìm kiếm tàu',
  'Invoice Tickets': 'Vé ngoài hệ thống',
  'Invoice Ticket List': 'Danh sách Vé ngoài hệ thống',
  'Invoice Ticket Create': 'Thêm Vé ngoài hệ thống',
  flightCalendar: 'Lịch trình',
  'Tour List': 'Tour Du Lịch',
  'Tour Detail': 'Chi tiết Tour',
  'Tour Booking List': 'Danh sách đặt Tour',
  'Tour Booking Detail': 'Chi tiết Tour đã đặt',
  'Book Tour': 'Đặt chỗ Tour',
  'Message Board': 'Bảng tin',
  'Find Booking By PNR - VN1A': 'Tìm PNR ngoài hệ thống - VN1A',
  'Find Booking By PNR - VN1A_MT': 'Tìm PNR ngoài hệ thống - VN1A_MT',
  'Find Booking By PNR - VJ': 'Tìm PNR ngoài hệ thống - VJ',
  'Find Booking By PNR - VU': 'Tìm PNR ngoài hệ thống - VU',
  'Find Booking By PNR - QH': 'Tìm PNR ngoài hệ thống - QH',
  'Find Booking By PNR - 1G': 'Tìm PNR ngoài hệ thống - 1G',
  'Find Booking By PNR - Other': 'Tìm PNR ngoài hệ thống - Khác',
  'Agent Request Stats': 'Thống kê request Tìm kiếm của F2',
  'Instructions for use': 'Hướng dẫn sử dụng',
  'Check-in online': 'Gỡ/Check-in online',
  'Flights Schedule': 'Bảng điện tử',
}
